var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallDd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10938 1.05052C1.2316 0.928298 1.38715 0.867187 1.57604 0.867187C1.76493 0.867187 1.92049 0.928298 2.04271 1.05052L4.64271 3.65052L7.24271 1.05052C7.36493 0.928298 7.52049 0.867187 7.70938 0.867187C7.89826 0.867187 8.05382 0.928298 8.17604 1.05052C8.29826 1.17274 8.35937 1.3283 8.35937 1.51719C8.35937 1.70608 8.29826 1.86163 8.17604 1.98385L5.10938 5.05052C5.04271 5.11719 4.97049 5.16452 4.89271 5.19252C4.81493 5.22008 4.7316 5.23385 4.64271 5.23385C4.55382 5.23385 4.47049 5.22008 4.39271 5.19252C4.31493 5.16452 4.24271 5.11719 4.17604 5.05052L1.10938 1.98385C0.987154 1.86163 0.926042 1.70608 0.926042 1.51719C0.926042 1.3283 0.987154 1.17274 1.10938 1.05052Z",
    fill: "#9C4900",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallDd);
export default __webpack_public_path__ + "static/media/smallDD.5a697a68ed636a2fce7cc1468e875665.svg";
export { ForwardRef as ReactComponent };